import { render, staticRenderFns } from "./giveaways-modal.vue?vue&type=template&id=cf0176ea&scoped=true&"
import script from "./giveaways-modal.vue?vue&type=script&lang=js&"
export * from "./giveaways-modal.vue?vue&type=script&lang=js&"
import style0 from "./giveaways-modal.vue?vue&type=style&index=0&id=cf0176ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0176ea",
  null
  
)

export default component.exports